import { Breadcrumbs, Stack, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useTranslation } from "react-i18next";

const Breadcrumb = ({ data }) => {
  const { i18n } = useTranslation();
  return (
    <Stack
      // mb={1}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      fontWeight="500"
    >
      <Breadcrumbs
        separator={
          <NavigateNextIcon
            fontSize="small"
            sx={{
              color: "#919293",
              rotate: i18n.language === "ar" ? "180deg" : 0,
            }}
          />
        }
        aria-label="breadcrumb"
      >
        {data?.map((breadcrumbs, index) => {
          if (breadcrumbs)
            return breadcrumbs?.active ? (
              <NavLink
                to={breadcrumbs?.path}
                style={{ textDecoration: "none" }}
                key={index}
              >
                <Typography
                  sx={{
                    fontFamily: "Cairo",
                    fontSize: "14px",
                    color: "#CACACA",
                  }}
                >
                  {breadcrumbs?.title}
                </Typography>
              </NavLink>
            ) : (
              <Typography
                key={index}
                sx={{ fontFamily: "Cairo", fontSize: "14px", color: "#919293" }}
              >
                {breadcrumbs?.title}
              </Typography>
            );
        })}
      </Breadcrumbs>
    </Stack>
  );
};

export default Breadcrumb;
